<inspection-menu (onReload)="onReload()" (outputDownload)="downloadInspectionFiltered()"></inspection-menu>
<h2>{{title}} for {{defaults.tenant}}</h2>
<inspection-filter (outputFilter)="getFilteredInspectionsByTenant()"></inspection-filter>
<inspection-list [list]="list" [showLocalFilter]="showLocalFilter"></inspection-list>